import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import az from "date-fns/locale/az";
import "./datePicker.css";
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar.svg";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";

export const DatePick = ({
  newGroupData,
  setNewGroupData,
  type,
  setDateWarningMessage,
}) => {
  registerLocale("az", az);
  const { startDate, endDate } = useSelector((state) => state.datepicker);

  const onHandleChange = (date) => {
    const filterStartDate = new Date(startDate);
    const filterEndDate = new Date(endDate);
    const selectedDate = new Date(date);

    // console.log(filterStartDate, "filtered start data");
    // console.log(filterEndDate, "filtered end data");
    // console.log(selectedDate, "selected  data");

    if (
      date &&
      (selectedDate < filterStartDate || selectedDate > filterEndDate)
    ) {
      let message;

      if (type === "startDate")
        message = "Başlama tarixi filterdəki tarix aralığında olmalıdır!";
      if (type === "endDate")
        message = "Bitmə tarixi filterdəki tarix aralığında olmalıdır!";

      setDateWarningMessage((pre) => ({ ...pre, [type]: message }));

      return;
    }
    setDateWarningMessage((pre) => ({ ...pre, [type]: "" }));
    setNewGroupData((pre) => ({ ...pre, [type]: date }));
  };

  return (
    <>
      <div className={`date-container `}>
        <div className="startdate-container">
          <label className="startdate-month">
            <CalendarIcon
              className="calendar-icon"
              style={{ cursor: "pointer" }}
            />
            <DatePicker
              selected={newGroupData[type]}
              onChange={(date) => onHandleChange(date)}
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              dateFormat="dd/MM/yyyy"
              placeholderText="dd/mm/yyyy"
              locale="az"
            />
          </label>
        </div>
      </div>
    </>
  );
};
